import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Question } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";
import CreateTicketModal from "./CreateTicketModal";

export default function SupportFloatingButton() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  if (!user || user.role === "admin") return null;
  if (pathname === "/doctor/queue-display" || pathname === "/staff/queue-display") return null;

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="fixed bottom-6 right-6 z-50 w-12 h-12 rounded-full bg-primary text-primary-foreground shadow-lg hover:bg-primary/90 transition-all hover:scale-105 flex items-center justify-center"
        aria-label="Get help"
      >
        <Question size={22} weight="bold" />
      </button>
      {open && <CreateTicketModal onClose={() => setOpen(false)} />}
    </>
  );
}
